export default {
  // Login & Logout
  login: '/admin_panel/login',
  logout: '/admin_panel/logout',

  // Leftbar
  devices: '/admin_panel/interface/devices',
  backup: '/admin_panel/admin_settings/backup',

  // Dashboard
  dashboard: '/admin_panel/dashboard',

  // Category
  category: '/admin_panel/ai_config/intents/category',

  // ai configuration
  ai_config_setting: '/admin_panel/ai_config/settings',
  ai_config_related_intents_on_off: '/admin_panel/ai_config/related_intents/on_off',
  ai_config_chatbot_on_off: '/admin_panel/ai_config/chatbot/on_off',
  ai_config_mrc_on_off: '/admin_panel/ai_config/mrc/on_off',

  // Intents
  intents: '/admin_panel/ai_config/intents/intent',
  intent_nav: '/admin_panel/ai_config/intents/nav',
  intent_autocomplete: '/admin_panel/ai_config/intents/auto_complete',
  intent_title: '/admin_panel/ai_config/intents/intent_title',
  intent_export: '/admin_panel/ai_config/intents/export',

  // Keyword
  keyword: '/admin_panel/ai_config/intents/keywords',
  button_payloads: '/admin_panel/ai_config/intents/button_payloads',

  // Keyword Finder
  column_finder: '/admin_panel/ai_config/intents/column_finder',
  finder: '/admin_panel/ai_config/intents/finder',

  // Copy Intent to another device
  copy_device: '/admin_panel/setup/copy_device',

  // Entity
  entity: '/admin_panel/ai_config/entities',
  // Alias
  alias_finder: '/admin_panel/ai_config/alias_finder',

  // MRC
  mrc: '/admin_panel/mrc',
  mrc_batch: '/admin_panel/mrc/batch',
  mrc_batch_enable: '/admin_panel/mrc/batch/enable',
  mrc_projects: '/admin_panel/mrc/projects',
  mrc_query: '/admin_panel/mrc/query',
  mrc_enable: '/admin_panel/mrc/enable',
  mrc_healthcheck: '/admin_panel/mrc/healthcheck',
  mrc_document: '/admin_panel/mrc/document',
  mrc_export: '/admin_panel/mrc/export',

  // Location and Map
  location: '/admin_panel/location_map/locations',
  map: '/admin_panel/location_map/maps',
  location_map_category: '/admin_panel/location_map/categories',

  // Small Talk
  small_talk: '/admin_panel/small_talk',

  // Interface Setting
  interface_setting: '/admin_panel/interface/sections',
  directory: '/admin_panel/directory',
  carousel: '/admin_panel/carousel',
  bottom_menu: '/admin_panel/bottom_menu',

  // Conversation Review
  conversation: '/admin_panel/conversation',

  // Response
  response: '/admin_panel/ai_config/intents/responses',
  upload_file: '/admin_panel/ai_config/upload',
  avatar_motion: '/admin_panel/ai_config/intents/avatar_motion',

  // Users
  user: '/admin_panel/admin_settings/users',
  change_password: '/admin_panel/admin_settings/change_password',
  logs: '/admin_panel/admin_settings/logs',

  // Chats
  chat: '/admin_panel/chat',

  // live video
  video_call: '/admin_panel/video_call/list',
  message: '/admin_panel/video_call/push',
  offline_hours: '/admin_panel/video_call/offline_hours',
  notification_channel: '/admin_panel/video_call/notification',

  // Interface Settings
  idle_screen: '/admin_panel/idle_screen',
  avatar: '/admin_panel/virtual_avatar',

  // Branding Images
  branding: '/admin_panel/branding',

  // Event Manager
  event_manager: '/admin_panel/event_manager',
  event: '/admin_panel/event_manager/event',
  quiz: '/admin_panel/event_manager/quiz',

  // Approval
  approval_status: '/admin_panel/approval/submission_status',
  device_changes: '/admin_panel/approval/device_changes',
  approval_requests: '/admin_panel/approval/approval_requests',
  approval_request: '/admin_panel/approval/approval_request',

  // Audio Preview
  audio_preview: '/admin_panel/ai_config/intents/audio_preview'
}
